import { CityClocks } from './CityClocks';

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer style={{ padding: '0 28px 28px', position: 'relative', zIndex: 2 }}>
      <CityClocks />
      <div
        className="footer-meta"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingTop: 16,
          fontSize: 10,
          textTransform: 'uppercase',
          letterSpacing: 0.8,
          opacity: 0.65,
          gap: 16,
        }}
      >
        <span>© 2001–{year} · DMERRITTS</span>
        <span>Set in Plex Mono &amp; Cormorant</span>
        <span>
          Press <b>K</b> for something fun
        </span>
        <span>END OF DOSSIER ░</span>
      </div>
    </footer>
  );
}
